import { useEffect, useState } from 'react'
import './nameDialog.css'
import { FolderNode, getNodeById } from '../WooNotes/folders'
import { DataResponseStatusIds, GUID } from '../Services/ServiceTypes'
import ServiceEditor, { IEditorAttachment } from '../Services/ServiceEditor'
import Util from '../Util'
import { IEditorAttachmentToBeRemoved } from './confirmRemoveAttachmentDialog'
import { WooNotesButton, WooNotesButtonSize, WooNotesButtonColor } from '../WooNotes/WooNotesButton'

type Props = {
  token: string
  nodeId: GUID | undefined
  folderNodes: FolderNode[]
  // onSave: (name: string) => void
  onCancel: () => void
  onError: (errorMessage: string) => void
  onInsertAttachment: (nodeId: GUID, editorAttachment: IEditorAttachment) => void

  editorAttachmentToBeRemoved: IEditorAttachmentToBeRemoved | undefined
  onRemoveAttachment: (nodeId: GUID, editorAttachment: IEditorAttachment) => void
}

export const NodeAttachmentsDialog = ({
  token,
  nodeId,
  folderNodes,
  onCancel,
  onError,
  onInsertAttachment,
  editorAttachmentToBeRemoved,
  onRemoveAttachment,
}: Props) => {
  const [editorAttachments, setEditorAttachments] = useState<IEditorAttachment[]>([])

  useEffect(() => {
    if (!nodeId) return

    const getData = async () => {
      const resp = await ServiceEditor.getEditorAttachments(token, nodeId)
      if (resp.Status.Id !== DataResponseStatusIds.General_OK) {
        onError(`Failed to load attachments (${resp.Status.Id})`)
        return
      }

      setEditorAttachments(resp.Data as IEditorAttachment[])
    }

    getData()
  }, [nodeId, editorAttachmentToBeRemoved])

  if (nodeId === undefined) return null
  const nodeName = getNodeById(folderNodes, nodeId)?.name
  if (nodeName === undefined) return null

  return (
    <div className="dialog-root">
      <div className="dialog-backdrop" onClick={onCancel} />

      <div className="dialog">
        <h3>Show attachments for {nodeName}</h3>

        <div className="dialog-content">
          {editorAttachments.length === 0 && <div>No attachments</div>}

          {editorAttachments.length > 0 && (
            <table>
              <thead>
                <tr>
                  <th>Filename</th>
                  <th>Size</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {editorAttachments.map(editorAttachment => (
                  <tr key={`editorAttachment${editorAttachment.Id}`}>
                    <td>{editorAttachment.Filename}</td>
                    <td>{Util.formatBytesSI(editorAttachment.Size)}</td>
                    <td>
                      <div className="tableactions">
                        <WooNotesButton
                          size={WooNotesButtonSize.Slim}
                          color={WooNotesButtonColor.Blue}
                          onClick={() => onInsertAttachment(nodeId, editorAttachment)}
                        >
                          Add
                        </WooNotesButton>
                        <WooNotesButton
                          size={WooNotesButtonSize.Slim}
                          color={WooNotesButtonColor.Red}
                          onClick={() => onRemoveAttachment(nodeId, editorAttachment)}
                        >
                          Delete
                        </WooNotesButton>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="actions">
          <WooNotesButton size={WooNotesButtonSize.Slim} color={WooNotesButtonColor.White} onClick={onCancel}>
            Close
          </WooNotesButton>
        </div>
      </div>
    </div>
  )
}
